var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3166_13201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5271 3.76221C18.6403 4.50451 19.5924 5.46374 20.3263 6.58251C21.0603 7.70127 21.561 8.95658 21.7986 10.2733C22.2123 10.5408 22.5469 10.914 22.7679 11.3543C22.9889 11.7946 23.0882 12.286 23.0555 12.7775C23.0228 13.2691 22.8593 13.7429 22.582 14.1501C22.3046 14.5572 21.9235 14.8828 21.478 15.0931C20.8336 17.0987 19.5692 18.848 17.8669 20.0889C16.1647 21.3299 14.1125 21.9986 12.0059 21.9986C9.89934 21.9986 7.84713 21.3299 6.1449 20.0889C4.44266 18.848 3.17825 17.0987 2.5338 15.0931C2.08834 14.8828 1.70719 14.5572 1.42983 14.1501C1.15247 13.7429 0.988984 13.2691 0.956289 12.7775C0.923595 12.286 1.02288 11.7946 1.24388 11.3543C1.46487 10.914 1.79954 10.5408 2.21322 10.2733C2.44607 8.98269 2.93181 7.7508 3.64249 6.64855C4.35317 5.5463 5.27476 4.59543 6.35426 3.85064",
    stroke: "#2F1C0A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23535 16.4746C9.5956 16.8423 10.0256 17.1344 10.5001 17.3338C10.9747 17.5332 11.4843 17.6359 11.999 17.6359C12.5137 17.6359 13.0233 17.5332 13.4979 17.3338C13.9724 17.1344 14.4024 16.8423 14.7626 16.4746",
    stroke: "#2F1C0A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12988 0.998535C9.78807 2.10399 10.8935 4.86763 10.8935 6.52582",
    stroke: "#2F1C0A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5518 0.998535C14.2099 3.20945 14.7627 4.86763 14.7627 6.52582",
    stroke: "#2F1C0A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68262 12.0527H8.69367",
    stroke: "#2F1C0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3154 12.0527H15.3265",
    stroke: "#2F1C0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3166_13201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildProfile);
export default __webpack_public_path__ + "static/media/childProfile.d412e42b408c9f8031a827171077d8bf.svg";
export { ForwardRef as ReactComponent };